import { launchModalOrRedirect } from "./redirect-free-image-search.js";

export function enableSearch() {
  const searchForm = document.querySelector('.search-form');

  searchForm.addEventListener('submit', event => {
    event.preventDefault();

    let searchTerm = searchForm.querySelector('input').value;
    searchTerm.length > 2 && launchModalOrRedirect(searchTerm);
  })
}

export const enableUserInteractionWithSamples = () => {
  const interactiveSearchElements = document.querySelectorAll('[data-toggle="search-image-stock"]');

  interactiveSearchElements.forEach(element => {
    element.addEventListener('pointerup', () => launchModalOrRedirect(element.dataset.photo ? element.dataset.photo : null ));
  });
}
